import pickUpNotification from './pick-up-notification.directive'

const module = angular.module('ac.components.pickup', [])

module.directive('pickUpNotification', pickUpNotification)

export default module.name
